/**
 * Created by Bart Decorte
 * Date: 24/06/2021
 * Time: 12:13
 */

export default class ColumnData extends Array {
  getByDatabaseName(name) {
    for (let i = 0; i < this.length; i++) {
      if (this[i].column_name === name) {
        return this[i];
      }
    }

    return;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/columns/objects/ColumnData.js